import React from 'react';
import * as DateUtils from 'utils/dates';

const CONFIGURATION = {};

export default CONFIGURATION;

/*
RIM.reimburse_info_mscon_id 
, RIM.mscon_country_id 
, C.CODE AS as mscon_country_code
, VRR.application_type
, RIM.reimbursement_reference 
, RIM.reimbursement_version 
, RIM.vat_return_received_id 
, RIM.vat_amount_reimbursed 
, RIM.vat_amount_to_be_reimbursed 
, RIM.reimbursement_request_date 
, RIM.reimbursement_date 
, RIM.iban 
, RIM.bic 
, RIM.account_holder 
, RIM.is_processed 
, RIM.created_by 
, RIM.created_at 
, RIM.modified_by 
, RIM.modified_at 
*/
export const TableColumns = [
  {
    label: '#',
    id: 'reimburse_info_mscon_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Originating Country',
    id: 'mscon_country_code',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Scheme Type',
    id: 'application_type',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Reimbursement Reference',
    id: 'reimbursement_reference',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Reimbursement Version',
    id: 'reimbursement_version',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{DateUtils.formatDate(cellValue)}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Vat Return Received ID',
    id: 'vat_return_received_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Vat Amount Reimbursed',
    id: 'vat_amount_reimbursed',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Vat Amount to be Reimbursed',
    id: 'vat_amount_to_be_reimbursed',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Reimbursement Request Date',
    id: 'reimbursement_request_date',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{DateUtils.formatDate(cellValue)}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Reimbursement Date',
    id: 'reimbursement_date',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{DateUtils.formatDate(cellValue)}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'IBAN',
    id: 'iban',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'BIC Code',
    id: 'bic',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Account Holder',
    id: 'account_holder',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Is Processed',
    id: 'is_processed',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue ? 'Yes' : 'No'}</React.Fragment>
    ),
    inData: true,
  },
];

interface ITableDefaultFetchValues {
  TABLE_DEFAULT_PAGE: number;
  TABLE_DEFAULT_PAGE_SIZE: number;
  TABLE_DEFAULT_ORDER: 'desc' | 'asc';
  TABLE_DEFAULT_SORT_KEY: string;
}

export const ReimbursementsReceivedTableDefaultFetchValues: ITableDefaultFetchValues =
  {
    TABLE_DEFAULT_PAGE: 0,
    TABLE_DEFAULT_PAGE_SIZE: 25,
    TABLE_DEFAULT_ORDER: 'desc',
    TABLE_DEFAULT_SORT_KEY: TableColumns[0].id,
  };
